import { DatePipe } from '@angular/common';
import { noUndefined } from '@angular/compiler/src/util';
import { Component, OnInit, TemplateRef, LOCALE_ID, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';
import * as alertifyjs from 'alertifyjs';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth/auth.service';
import Swal from'sweetalert2';
import { MbscDatetimeOptions } from '@mobiscroll/angular';

@Component({
  selector: 'app-contact-onboarding',
  templateUrl: './contact-onboarding.component.html',
  styleUrls: ['./contact-onboarding.component.css'],
  providers: [DatePipe],
})
export class ContactOnboardingComponent implements OnInit {
  mobileSettingsFile: MbscDatetimeOptions = {
    display: 'bottom',
  };
  
  // Configuraciones para date picker de fecha de nacimiento
  mobileSettings: MbscDatetimeOptions = {
    display: 'bottom',
    themeVariant: 'dark',
  };

  desktopSettings: MbscDatetimeOptions = {
    display: 'bubble',
    touchUi: false
  };
  
  showWebcam = false;

  commentText: any;

  @Input() personCode: any;
  @Input() fromRevision: boolean = false;
  @Input() isModal: boolean = false;
  
  @Output() onComplete = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<void>();

  queryParams: any;
  person: any;
  biometria_data: any;

  declinedStatus = false;
  abandonedStatus = false;
  approvedStatus = false;
  biometricEnabledStatus = false;

  showButtons: boolean = true;

  image: any;
  loading_img = false;
  ciClickCounter = 0;
  selfieClickCounter = 0;
  showCiMsg = false;
  showSelfieMsg = false;

  biometricStatusCounter = 0;
  statusLoading = false;
  loadingBiometric = false;
  showStatusMsg = false;

  section_transactions: any = [];
  transaction: any = {};
  section_transaction: any = {};  // Initialize with empty object instead of undefined
  biometrics_h: any = {};

  loading = false;
  buro_response: any;
  buro: any;
  buro_score: any;
  activatePsico: any;
  showActivatePsico: any;

  loading_buro = false;
  psicometrico: any;
  psicometrico_response: any;
  psicometrico_array: any = [];
  status_approved: any;
  type_approved: any;
  clientQuota: any;
  biometria = false;
  imgPerson: any;
  start_psicometrico: any;
  view: any = 1;
  loading_bio: any;
  loading_bio_h: any;
  inReview = false;

  manual_verification_list: any;

  current_payment_method_id: any;
  start_psicometrico_load = true;

  domiciliations: any = [];

  domiciliation_current: any = [];

  //variables analysis
  loading_analysis = false;
  analysis_response: any;
  approve_type_person: any;
  loading_mv = false;

  history:boolean = false;
  historyList:any;

  expandedSteps: { [key: string]: boolean } = {
    'profile_data': false,
    'analysis': false,
    'biometric': false
  };

  // Variables para edición de fecha de nacimiento en modal biométrico
  editingBirthDate: boolean = false;
  birthDateEdit: any;
  birthDateEditString: any;
  savingBirthDate: boolean = false;

  // Referencia al offcanvas biométrico abierto
  private biometricOffcanvasRef: any = null;

  // Payment methods tracking
  hasPaymentMethods: boolean = false;

  // Profile data validation
  personAddresses: any = [];
  customerData: any = {};

  @ViewChild('content') content!: TemplateRef<any>;
  @ViewChild('content2') content2!: TemplateRef<any>;
  @ViewChild('content3') content3!: TemplateRef<any>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    private datePipe: DatePipe,
    public socketService: SocketioService,
    private offcanvasService: NgbOffcanvas,
    public _auth: AuthService,
    private _common: CommonService
  ) {}

  async ngOnInit() {
    console.log('ContactOnboardingComponent ngOnInit', {
      personCode: this.personCode,
      isModal: this.isModal,
      fromRevision: this.fromRevision
    });

    /* this.socketService.resetDataClientCode.subscribe((person_code: any) => {
      if (person_code && person_code == this.person?.person.code) {
        this.getSection_transaction_by_person();
      }
    });*/

    // Si se pasa personCode como input (modo modal), usarlo directamente
    if (this.personCode) {
      console.log('Modo modal detectado, usando personCode:', this.personCode);
      this.queryParams = { code: this.personCode };
      
      try {
        await this.getPerson();
        console.log('Persona cargada exitosamente en modo modal');
        
        // Si viene de revisión, abrir automáticamente el modal biométrico
        if (this.fromRevision && this.content3) {
          console.log('Abriendo modal biométrico automáticamente (fromRevision=true)');
          setTimeout(() => {
            this.openBiometricModalFromRevision();
          }, 500);
        }
      } catch (error) {
        console.error('Error al cargar persona en modo modal:', error);
        // NO cerrar el modal automáticamente, dejar que el usuario vea el error
        // y decida si quiere cerrar o reintentar
      }
    } else {
      console.log('Modo página completa, usando ActivatedRoute');
      // Si no, usar los parámetros de la ruta (modo página completa)
      this.activatedRoute.params.subscribe((params) => {
        this.queryParams = params;
        if (this.queryParams?.code) {
          this.getPerson();
        }
      });
      
      // NO abrir automáticamente ningún modal
      // El usuario decidirá qué revisar desde la vista principal del onboarding
    }

    try {
      this.domiciliations = await this.getActiveDomiciliations();
      console.log('Domiciliations:', this.domiciliations);
      this.domiciliation_current = this.domiciliations.find(
        (elem: any) => elem.direct_debit_default
      );
    } catch (error) {
      console.error('Error al cargar domiciliations:', error);
    }

    try {
      await this.getHistoryVerificationManual();
    } catch (error) {
      console.error('Error al cargar history:', error);
    }
  }

  toggleWebcam() {
    this.showWebcam = !this.showWebcam;
  }

  getActiveDomiciliations = async () => {
    try {
      let resp = await this._common.getPayment_method({
        code_person: this.queryParams.code,
      });
      const activeDomiciliations = resp.resp.filter((row: any) => {
        if (row?.bank?.direct_debit_afiliation_required) {
          return (
            row.terms_and_condition !== undefined &&
            row?.afiliation?.status === 'COMPLETE'
          );
        } else {
          return row.terms_and_condition !== undefined;
        }
      });

      // Check if there are any payment methods (not just active domiciliations)
      this.hasPaymentMethods = resp.resp && resp.resp.length > 0;

      return activeDomiciliations;
    } catch (error) {
      console.log(error);
      this.hasPaymentMethods = false;
      return [];
    }
  };

  // Check if profile data section is complete
  isProfileDataComplete(): boolean {
    // Check only: addresses, working condition, income (NOT payment methods)
    return this.hasAddresses() && this.hasWorkingCondition() && this.hasIncome();
  }

  // Check if user has addresses (both work and home)
  hasAddresses(): boolean {
    return this.personAddresses && this.personAddresses.length > 0;
  }

  // Check if user has working condition
  hasWorkingCondition(): boolean {
    return this.customerData?.working_condition &&
           this.customerData?.working_condition.trim() !== '';
  }

  // Check if user has income (amount with actual number, not just "USD")
  hasIncome(): boolean {
    return this.customerData?.amount &&
           this.customerData?.amount !== null &&
           this.customerData?.amount !== '' &&
           !isNaN(parseFloat(this.customerData?.amount)) &&
           parseFloat(this.customerData?.amount) > 0;
  }

  // Payment methods always show pending (orange clock)
  hasPaymentMethodsCompleted(): boolean {
    return this.hasPaymentMethods; // Return actual payment methods status
  }

  // Get the status text for profile data
  getProfileDataStatus(): string {
    return this.isProfileDataComplete() ? 'Completado' : 'Pendiente';
  }

  // Get the status icon class for profile data
  getProfileDataStatusIcon(): string {
    return this.isProfileDataComplete() ? 'fas fa-check-circle status-icon completed' : 'fas fa-clock status-icon pending';
  }

  // Load profile data for validation
  loadProfileDataForValidation = async () => {
    try {
      // Load addresses
      const addressResp = await this._common.getPerson_Address({
        code_person: this.queryParams.code
      });
      this.personAddresses = addressResp?.resp || [];

      // Load customer data (working condition and income)
      const customerResp = await this._common.getcustomer({
        code_person: this.queryParams.code
      });
      this.customerData = customerResp?.resp || {};

    } catch (error) {
      console.log('Error loading profile data:', error);
      this.personAddresses = [];
      this.customerData = {};
    }
  };

  // Refresh payment methods to update status
  async refreshPaymentMethods() {
    this.domiciliations = await this.getActiveDomiciliations();
    // Also refresh profile data validation
    await this.loadProfileDataForValidation();
  }

  getPerson = async () => {
    try {
      console.log('getPerson iniciado con queryParams:', this.queryParams);
      this.loading = true;
      
      if (!this.queryParams || !this.queryParams.code) {
        throw new Error('No se proporcionó código de persona');
      }

      const resp = await this._user.getPersonbyCode({
        code: this.queryParams.code,
      });
      
      console.log('Respuesta de getPersonbyCode:', resp);
      
      if (!resp || !resp.resp) {
        throw new Error('No se recibió respuesta válida del servidor');
      }

      this.person = resp.resp;
      this.personCode = this.person.person.code;
      this.imgPerson = this.person?.person?.file_selfie?.url;

      if (this.person?.person) {
        this.activatePsico = this.person?.person?.active_psicometrico;
        
        // Cargar datos de forma segura con try-catch individuales
        try {
          this.getSectionTransactionsProgres();
        } catch (e) {
          console.warn('Error en getSectionTransactionsProgres:', e);
        }
        
        try {
          this.getSection_transaction_by_person();
        } catch (e) {
          console.warn('Error en getSection_transaction_by_person:', e);
        }
        
        try {
          this.getAnalysis(this.person);
        } catch (e) {
          console.warn('Error en getAnalysis:', e);
        }
        
        try {
          this.getAnalysisDetail(this.person);
        } catch (e) {
          console.warn('Error en getAnalysisDetail:', e);
        }
        
        try {
          this.getInReview(this.person);
        } catch (e) {
          console.warn('Error en getInReview:', e);
        }
        
        try {
          this.manual_verification();
        } catch (e) {
          console.warn('Error en manual_verification:', e);
        }

        // Load profile data for validation
        try {
          await this.loadProfileDataForValidation();
        } catch (e) {
          console.warn('Error en loadProfileDataForValidation:', e);
        }
      }

      // Mostrar la UI inmediatamente, sin esperar biometría
      this.loading = false;
      console.log('getPerson completado exitosamente — cargando biometría en segundo plano');

      // Cargar biometría en segundo plano (API externa, puede ser lenta)
      if (this.person?.person) {
        this.loadBiometricsInBackground();
      }
    } catch (error: any) {
      console.error('Error en getPerson:', error);
      this.loading = false;
      
      // Mostrar error más descriptivo
      let errorMessage = 'Error desconocido';
      
      if (error?.error?.message) {
        errorMessage = error.error.message;
      } else if (error?.message) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      }
      
      console.error('Mensaje de error:', errorMessage);
      console.error('Código de persona que causó el error:', this.queryParams?.code);
      
      // Detectar si es un error de "usuario no encontrado"
      if (errorMessage.toLowerCase().includes('no encontr') || 
          errorMessage.toLowerCase().includes('not found')) {
        alertifyjs.error('Cliente no encontrado. Verifica que el código sea correcto: ' + this.queryParams?.code);
      } else {
        alertifyjs.error('Error al cargar información del cliente: ' + errorMessage);
      }
      
      // Si estamos en modo modal, ofrecer cerrar
      if (this.isModal) {
        console.log('Modal permanece abierto. El usuario puede cerrarlo manualmente.');
      }
      
      // NO re-lanzar el error para que el modal permanezca abierto
      // El usuario puede ver el error y decidir si cerrar
    }
  };

  loadBiometricsInBackground() {
    this.biometrics_data().then((updatedBiometrics: any) => {
      this.biometria_data = updatedBiometrics;
      if (this.biometria_data?.person_biometric?.status !== undefined) {
        switch (this.biometria_data.person_biometric.status) {
          case 'Declined':
            this.declinedStatus = true;
            break;
          case 'Abandoned':
            this.abandonedStatus = true;
            break;
          case 'Accepted':
            this.approvedStatus = true;
            break;
        }
      }
      console.log('Biometría cargada en segundo plano');
    }).catch((e: any) => {
      console.warn('Error cargando biometría en segundo plano:', e);
    });
  }

  getSection_transaction_by_person = async (buro: any = true) => {
    try {
      const resp = await this._user.getSection_transaction_by_person({
        code: this.queryParams.code,
        type: 'ONBOARDING',
      });

      const result = resp.resp;
      let temp: any = {};

      if (result?.section_transactions?.length > 0) {
        result?.section_transactions.map((obj: any) => {
          temp[obj?.section_transaction?.code] = obj;
          return obj;
        });
      }

      this.section_transaction = temp;
      this.transaction = result?.transaction;

      console.log('Section transaction loaded:', this.section_transaction);
    } catch (error) {
      console.log('Error loading section transactions:', error);
      // Initialize with empty object to prevent hiding progress section
      this.section_transaction = {};
      this.transaction = null;
    }
  };

  /*
  getSectionTransactions = async () => {

    let filter = { type: 'ONBOARDING' };

    const resp = await this._user.getSectionTransactions(filter);
    this.section_transactions = resp.resp;
  };
*/

  getSectionTransactionsProgres = async () => {
    try {
    let body = {
      type: 'ONBOARDING',
      code: this.person.person.code,
    };

    const resp = await this._user.getSectionTransactionsProgres(body);
      this.section_transactions = resp || [];

      console.log('Section transactions progress loaded:', this.section_transactions);
    } catch (error) {
      console.log('Error loading section transactions progress:', error);
      // Initialize with empty array to prevent errors
      this.section_transactions = [];
    }
  };

  getIdentity(item: any) {
    if (!(item?.identitys?.length > 0)) return '';

    return `${item?.identitys[0]?.type_identity?.name} ${item?.identitys[0]?.code_identity?.name}-${item?.identitys[0]?.identity}`;
  }

  getContact(item: any) {
    if (!(item?.constacts?.length > 0)) return '';

    return `${item?.constacts[0]?.contact}`;
  }

  // Método para obtener solo el número de cédula (sin tipo ni nacionalidad)
  getIdentityNumber(item: any): string {
    if (!(item?.identitys?.length > 0)) return '';
    return item?.identitys[0]?.identity || '';
  }

  // Método para copiar número de cédula al portapapeles
  async copyIdentityToClipboard(person: any): Promise<void> {
    try {
      const identityNumber = this.getIdentityNumber(person);
      if (identityNumber) {
        // Copiar al portapapeles
        await navigator.clipboard.writeText(identityNumber);
        
        // Mostrar notificación con alertifyjs
        alertifyjs.success(`Cédula copiada al portapapeles`);
      }
    } catch (error) {
      console.error('Error al copiar cédula:', error);
      // Fallback para navegadores que no soportan navigator.clipboard
      this.fallbackCopyIdentityToClipboard(person);
    }
  }

  // Método fallback para copiar cédula en navegadores más antiguos
  fallbackCopyIdentityToClipboard(person: any): void {
    try {
      const identityNumber = this.getIdentityNumber(person);
      if (identityNumber) {
        // Crear elemento temporal
        const textArea = document.createElement('textarea');
        textArea.value = identityNumber;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        
        // Mostrar notificación con alertifyjs
        alertifyjs.success(`Cédula copiada al portapapeles`);
      }
    } catch (error) {
      console.error('Error en fallback de copiado cédula:', error);
    }
  }

  sanitize(url: string) {
    //return url;
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  //juan : funcion deprecada
  getDataBuro = async (item: any, reload = true) => {
    this.loading_buro = true;

    try {
      if (item?.identitys?.length > 0) {
        let cde = item?.identitys[0]?.code_identity?.code == 'V' ? 1 : 3;
        let params = {
          type_identity: cde,
          identity: item?.identitys[0]?.identity,
          lastName: item?.person?.lastName,
          code_person: item?.person?.code,
        };

        const buro = await this._user.getDataBuro(params);

        this.buro = buro?.resp;
        if (this.buro?.status_approved == 'WAIT_PSICOMETRICO') {
          // this.getScorePsicometrico(item, params);

          let d = new Date(this.buro?.consult_psicometrico_date);
          let dNew = new Date();

          if (dNew > d) {
            this.start_psicometrico = true;
          }
        }

        this.person.person = this.buro?.person;

        this.setResponseBuro(this.buro);
        this.loading_buro = false;

        if (reload) {
          this.getSection_transaction_by_person(true);
        }
      }
    } catch (error: any) {
      this.loading_buro = false;

      console.error(error);
      alertifyjs.error(error?.error?.msg);
    }
  };

  send_responsea_approvated = async () => {
    this.loading_buro = true;

    try {
      let params = {
        code_person: this.person?.person?.code,
      };

      const response = await this._user.send_responsea_approvated(params);
      alertifyjs.success(`Mensaje enviado exitosamente`);

      this.loading_buro = false;
    } catch (error) {
      console.log(error);
    }
  };

  getDataBuroSimple = async (item: any, reload = true) => {
    this.loading_buro = true;

    if (item?.identitys?.length > 0) {
      let cde = item?.identitys[0]?.code_identity?.code == 'V' ? 1 : 3;

      let params = {
        type_identity: cde,
        identity: item?.identitys[0]?.identity,
        lastName: item?.person?.lastName,
        code_person: item?.person?.code,
      };

      const buro = await this._user.getDataBuro(params);

      this.buro = buro?.resp;

      this.person.person = this.buro?.person;

      this.setResponseBuro(this.buro);
      this.loading_buro = false;
    }
  };

  setResponseBuro(resp: any) {
    const { status_approved, type_approved } = resp;

    this.status_approved = status_approved;
    this.type_approved = type_approved;
  }

  public redirect = () => {
    /*
      data = {
        firstName: "juan",
        lastName: "soto",
        dateOfBirth: "02/06/1999",
        gender: "male",
        mobile: "0404040404",
        email: "juan@kyryll.com"
      }
    */

    let Doc_ID;
    let Type_ID;
    let TLF;

    if (this.person?.identitys?.length > 0) {
      const data = this.person?.identitys[0];
      Type_ID = data.type_identity?.additionalType;
      Doc_ID = data.identity;
    }

    // if(!(item?.constacts?.length > 0))
    // return "";

    // return `${item?.constacts[0]?.contact}`;

    const data = {
      CED: environment.CED,
      IP: environment.IP_LOCAL,
      Type_ID,
      Doc_ID,
      PN: this.person?.person?.name,
      PA: this.person?.person?.lastName,
      FN: this.datePipe.transform(
        this.person?.person?.birth_date,
        'yyyy-MM-dd'
      ),
      GN: this.person?.person?.gender,
      TLF: '',
      EMAIL: '',
    };

    this.redirecFormService.postRedirect(
      environment.externalPsicometrico,
      data
    );
  };

  //preguntar a vincent
  getScorePsicometrico = async (item: any, params2: any) => {
    debugger;
    try {
      if (item?.identitys?.length > 0) {
        const params = {
          DocID: item?.identitys[0]?.identity,
          //"DocID":"11314836",
          TypeID: item?.identitys[0]?.code_identity?.code,
          ClieID: environment.ClieID,
          IP: environment.IP_LOCAL,
          code_person: this.person?.person?.code,
        };
        let psicometrico = await this._user.getScorePsicometrico(params);

        let status = psicometrico?.res?.status_approved;

        // se comenta temporalmente
        /*  if (status != 'WAIT_PSICOMETRICO') {
        if (status != 'WAIT_PSICOMETRICO') {

          this.getDataBuroSimple(item, params2);
        }*/
      }
    } catch (error) {
      console.error(error);
    }

    this.start_psicometrico_load = false;
  };

  setStatus_psicometrico = async (active_psicometrico: boolean) => {
    const resp = await this._user.setStatus_psicometrico({
      code: this.queryParams.code,
      active_psicometrico,
    });
    this.person.person = resp.resp;
    this.imgPerson = this.person?.person?.file_selfie?.url;
    this.activatePsico = active_psicometrico;
  };

  sendteminosClient = async () => {
    let msg = `Creditotal. Terminos ${environment.BASE_FORNT2}/verification/approve-conditions/${this.queryParams?.code}`;
    let number = this.getContact(this.person);

    try {
      const data = {
        number,
        msg,
      };

      //  await this._user.send_whatsapp(data);
      this.sendNoteClient(msg, number);

      //  alertifyjs.success(`Mensaje enviado exitosamente`);
    } catch (error) {
      console.error(error);
    }
  };

  sendNoteClient = async (msg: any, phone: any) => {
    try {
      const data = {
        phone,
        msg,
        client: 'CrediTotal',
      };

      let result = await this._user.sendsmsGeneral(data);
      alertifyjs.success(`Mensaje enviado exitosamente`);

      if (!result?.error) {
      }
    } catch (error) {
      console.error(error);
    }
  };

  setBiometria(param: any) {
    this._user.setBiometria({ type: param, person: this.person?.person?.code });
  }

  redirectIMG(url: String) {
    debugger;
    const link = `${url}`;
    window.open(link, '_blank');
  }

  pocisionBottom = async (content: TemplateRef<any>, data: any = {}) => {
    try {
      this.offcanvasService.open(content, {
        position: 'bottom',
        keyboard: false,
      });
    } catch (error) {
      console.log(error);
    }
  };

  offcanvasServiceClose() {
    this.view = 1;
    this.offcanvasService.dismiss();
  }

  editPaymentMethod(event: any) {
    this.current_payment_method_id = event.id;
    this.setChangView(event.view);
  }

  editBaseData(event: any) {
    //this.current_payment_method_id = event.id;
    this.setChangView(event.view);
  }

  setChangView(view: any) {
    console.log('🔄 [setChangView] Cambiando view a:', view);
    this.view = view;
    console.log('📍 [setChangView] view actual:', this.view);
  }

  setChangViewPerson(view: any) {
    this.getPerson();
    this.view = view;
  }

  setResetStatus(data: any) {
    this.getPerson();
    this.getSection_transaction_by_person();
    this.getSectionTransactionsProgres();
    // Refresh payment methods and profile validation data
    this.refreshPaymentMethods();
  }

  getInReview = async (item: any) => {
    debugger;
    try {
      this.loading_analysis = true;

      let params = {
        id: item?.person?._id,
      };

      let inReview = await this._user.getInReview(params);
      console.log(inReview);

      this.inReview = inReview?.resp;
      console.log(this.inReview);
    } catch (error) {
      this.loading_analysis = false;
    }
  };

  // Ajustes de nueva version de aprobación

  getAnalysis = async (item: any, reload = true) => {
    try {
      this.loading_analysis = true;



      let params = {
        codePerson: item?.person?.code,
      };

      const analysis = await this._user.getAnalysis(params);

      this.analysis_response =
        Object.keys(analysis?.result).length > 0 &&
        analysis?.result?.constructor === Object
          ? analysis?.result
          : null;

      if (this.analysis_response.transaction_status == 'INCOMPLETE') {
        this.analysis_response.showStatusValue = 'Pendiente';
      } else if (this.analysis_response.transaction_status == 'COMPLETE') {
        this.analysis_response.showStatusValue = 'Completa';
      }

      this.status_approved = this.analysis_response.approve_status;

      if (this.analysis_response.approve_status == 'REFUSED' && this.analysis_response.reconsideracion) {
        this.analysis_response.showStatusApprove = 'En reconsideración';
      } else if (this.analysis_response.approve_status == 'REFUSED') {
        this.analysis_response.showStatusApprove = 'Rechazado';
      } else if (this.analysis_response.approve_status == 'APPROVED') {
        this.analysis_response.showStatusApprove = 'Aprobado';
      } else if (
        this.analysis_response?.approve_status == 'PENDING' &&
        this.analysis_response?.next_approve_type == 'BURO_PSICOMETRICO'
      ) {
        /*this.getScorePsicometrico(item, params);
        let d = new Date(this.buro?.consult_psicometrico_date);
        let dNew = new Date();

        if (dNew > d) {
        }
        */

        this.start_psicometrico = true;

        this.analysis_response.showStatusApprove = 'En espera por psicometrico';

        this.status_approved = 'BURO_PSICOMETRICO';
      }

      setTimeout(() => {
        this.loading_analysis = false;
      }, 1000);

      if (reload) {
        this.getSection_transaction_by_person(true);
      }
    } catch (error) {
      this.loading_analysis = false;
    }
  };

  getAnalysisDetail = async (item: any, reload = true) => {
    try {
      let params = {
        codePerson: item?.person?.code,
      };

      const approve_type_person = await this._user.approve_type_person(params);

      this.approve_type_person = approve_type_person?.result;
    } catch (error) {
      this.loading_analysis = false;
    }
  };

  getDecisiveApprovalItem(): any | null {
    if (!Array.isArray(this.approve_type_person)) return null;
    return this.approve_type_person.find((i: any) => i?.isDecisive === true) || null;
  }

  getPolicyModeLabel(mode: string | null | undefined): string {
    const map: Record<string, string> = {
      ALTERNATING_ROTATION: 'Rotación alternada',
      FIXED_MT: 'Fijo MT',
      FIXED_CREDOLAB: 'Fijo Credolab',
      REQUIRE_BOTH: 'Requiere ambos',
      SPLIT_50_50_HASH: 'Split 50/50',
      FIXED_MT_FALLBACK: 'Fijo MT (fallback)',
      HYBRID_CREDOLAB_MT: 'Híbrido (Credolab + edad y empleo MT)',
    };
    if (!mode) return '';
    return map[mode] ?? mode;
  }

  getDecisiveHandlerLabel(item: any): string {
    const name = item?.approve_type_name;
    if (name === 'MUNDO_TOTAL_SCORE') return 'Mundo Total Score';
    if (name === 'CREDOLAB_SCORING') return 'Credolab';
    return name || '—';
  }

  getMtMotivoLabel(motivo: string | null | undefined): string {
    switch (motivo) {
      case 'work_condition_refused': return 'Condición laboral en lista de rechazo';
      case 'no_matching_group':      return 'No hay grupo que coincida con edad, sueldo y condición laboral';
      default:                       return motivo || 'Sin motivo registrado';
    }
  }

  /**
   * Modelos de score de un ATP de Credolab, del más nuevo al más viejo.
   * Cubre las tres generaciones de documento:
   *   · nuevo    → response.scoreModels.models.{score,score_v2}
   *   · anterior → response.attributeInsights.{score,score_v2}.value
   *   · legacy   → response.scoring (code score_97)
   * Los dos modelos se muestran siempre; `decided` marca cuál decidió.
   */
  getCredolabModels(item: any): any[] {
    const r = item?.response;
    if (!r) return [];

    const labels: Record<string, string> = { score_v2: 'Modelo nuevo (v2)', score: 'Modelo anterior' };
    const decided = r.scoreModels?.decidedWith ?? r.scoreModelAtDecision ?? null;
    const out: any[] = [];

    const push = (key: string, m: any, isDecided: boolean) => {
      if (!m || typeof m.score !== 'number') return;
      out.push({
        key,
        label: labels[key] || key,
        score: m.score,
        probability: typeof m.probability === 'number' ? m.probability : null,
        minScore: typeof m.minScore === 'number' ? m.minScore : null,
        passed: typeof m.passed === 'boolean' ? m.passed : null,
        decided: isDecided,
      });
    };

    const stored = r.scoreModels?.models;
    if (stored) {
      for (const key of ['score_v2', 'score']) push(key, stored[key], key === decided);
      return out;
    }

    // Documentos anteriores al guardado de scoreModels
    for (const key of ['score_v2', 'score']) {
      push(key, r.attributeInsights?.[key]?.value, decided ? key === decided : key === 'score');
    }
    if (out.length === 0) push('score', r.scoring, true);
    return out;
  }

  getCredolabDecisionLabel(description: string | null | undefined): string | null {
    if (!description) return null;
    if (description.startsWith('credolab_ok:')) return 'Aprobado por umbrales de score/probabilidad';
    if (description.startsWith('credolab_threshold_fail:')) return 'Score o probabilidad fuera de umbral';
    if (description.startsWith('credolab_auto_refuse_flags:')) return 'Flags de auto-rechazo disparados';
    if (description === 'credolab_no_scoring_in_upload') return 'Upload sin scoring calculado';
    if (description === 'credolab_no_cl_o_onboarding') return 'Sin upload de onboarding en Credolab';
    if (description.startsWith('credolab_handler_exception:')) return 'Error al evaluar Credolab';
    return description;
  }

  getCredolabTriggeredFlags(description: string | null | undefined): string[] {
    if (!description) return [];
    if (!description.startsWith('credolab_auto_refuse_flags:')) return [];
    const csv = description.split(':')[1] || '';
    return csv.split(',').map((s: string) => s.trim()).filter(Boolean);
  }

  // ============================================================
  // Bloque 2.6 — Helpers UI del modal "Detalles de aprobación"
  // ============================================================

  getApprovalStatusLabel(status: string | null | undefined): string {
    const map: Record<string, string> = {
      APPROVED: 'Aprobado',
      REFUSED: 'Rechazado',
      PENDING: 'Pendiente',
    };
    if (!status) return '—';
    return map[status] ?? status;
  }

  copyResponseJson(event: Event, response: any): void {
    event.preventDefault();
    event.stopPropagation();
    try {
      const text = JSON.stringify(response, null, 2);
      navigator.clipboard.writeText(text);
      alertifyjs.success('JSON copiado al portapapeles');
    } catch (e) {
      alertifyjs.error('No se pudo copiar al portapapeles');
    }
  }

  getRiskLabel(overallRisk: string | null | undefined): string {
    const map: Record<string, string> = {
      low: 'Bajo',
      medium: 'Medio',
      high: 'Alto',
    };
    if (!overallRisk) return '—';
    return map[overallRisk] ?? overallRisk;
  }

  /**
   * Traduce el code oficial de un flag Credolab a su label en español.
   * Fuente de verdad: services/credolab_risk_catalog.js del backend.
   * Si el catálogo se expande en backend, sincronizar esta tabla manualmente.
   */
  private readonly CREDOLAB_FLAG_LABELS: Record<string, string> = {
    riskEmulator:                               'Emulador',
    riskRootedDevice:                           'Dispositivo rooteado',
    riskHostApplicationCloned:                  'App host clonada',
    riskApplicationClonerUsage:                 'Uso de app clonadora',
    riskApplicationManipulation:                'Manipulación de app',
    riskControlledFromComputer:                 'Controlado desde PC',
    riskRemoteAccess:                           'Acceso remoto',
    riskDeviceIdChangerUsage:                   'Cambio de device ID',
    riskDeviceFarm:                             'Device farm',
    riskEmptyDevice:                            'Dispositivo vacío',
    riskNewDevice:                              'Dispositivo nuevo',
    riskAutomation:                             'Automatización',
    riskTorUsage:                               'Uso de TOR',
    riskVpnUsage:                               'Uso de VPN',
    riskHttpProxy:                              'Proxy HTTP',
    riskLocationSpoofing:                       'Ubicación falseada',
    riskTimeManipulation:                       'Manipulación de hora',
    riskGeographyMismatch:                      'Inconsistencia geográfica',
    riskTemporaryEmailUsage:                    'Email temporal',
    riskAnonymousMessengerUsage:                'Mensajería anónima',
    riskCryptoEnthusiast:                       'Perfil cripto',
    riskApplicationGamblingUsage:               'Apps de apuestas',
    riskFinancialApplicationsInstallationSurge: 'Surge de apps financieras',
    riskNonMarketApplicationUsage:              'App host fuera de market',
    riskHostApplicationNotInstalledFromMarket:  'Otras apps fuera de market',
  };

  getFlagLabel(code: string): string {
    return this.CREDOLAB_FLAG_LABELS[code] || code;
  }

  getMotorIdentity(item: any): { key: string, icon: string, color: string, title: string, subtitle: string | null } {
    const name = item?.approve_type_name || item?.approve_type?.name;
    switch (name) {
      case 'MUNDO_TOTAL_SCORE':
        return { key: 'mt',       icon: 'fa-building',     color: 'emerald', title: 'Score Mundo Total',       subtitle: null };
      case 'CREDOLAB_SCORING':
        return { key: 'credolab', icon: 'fa-shield-alt',   color: 'violet',  title: 'Credolab',                subtitle: null };
      case 'BURO':
        return { key: 'buro',     icon: 'fa-chart-line',   color: 'blue',    title: 'Buró',                    subtitle: 'Historial crediticio externo' };
      case 'MANUAL_SYSTEM':
        return { key: 'manual',   icon: 'fa-user-check',   color: 'slate',   title: 'Revisión manual',         subtitle: 'Decisión tomada por ejecutivo' };
      case 'IDENTITY_DATA_COMPARISON':
        return { key: 'identity', icon: 'fa-id-card',      color: 'slate',   title: 'Comparación de identidad', subtitle: 'Validación biométrica / documental' };
      default:
        return { key: 'other',    icon: 'fa-check-circle', color: 'slate',   title: item?.approve_type?.description || item?.approve_type?.name || 'Evaluación', subtitle: '' };
    }
  }

  hasMotivo(item: any): boolean {
    const name = item?.approve_type_name || item?.approve_type?.name;
    if (name === 'CREDOLAB_SCORING') {
      return !!this.getCredolabDecisionLabel(item?.description);
    }
    if (name === 'MUNDO_TOTAL_SCORE' && item?.approve_status === 'REFUSED') {
      const motivo = item?.response?.motivo_rechazo ?? item?.response?.customer_data?.motivo_rechazo;
      return !!motivo;
    }
    return false;
  }

  getExecutionOrder(item: any): number {
    if (!Array.isArray(this.approve_type_person)) return 0;
    const sorted = [...this.approve_type_person].sort((a: any, b: any) => {
      const da = new Date(a?.date || 0).getTime();
      const db = new Date(b?.date || 0).getTime();
      return da - db;
    });
    const idx = sorted.findIndex((x: any) => x?._id === item?._id);
    return idx >= 0 ? idx + 1 : 0;
  }

  getExecutionOrderLabel(item: any): string {
    const n = this.getExecutionOrder(item);
    if (n === 0) return '';
    return `${n}ª ejecutada`;
  }

  // Modo híbrido: aprobado por Credolab sin la edad o el empleo de MT (approve.reconsideracion).
  enReconsideracion(): boolean {
    return this.analysis_response?.approve_status == 'REFUSED' && !!this.analysis_response?.reconsideracion;
  }

  motivoReconsideracion(): string {
    const map: Record<string, string> = {
      'hibrido:empleo_rechazado': 'Credolab lo aprobó, pero su tipo de empleo no se admite',
      'hibrido:empleo_sin_grupo': 'Credolab lo aprobó, pero su tipo de empleo no está en ningún grupo de aprobación',
      'hibrido:edad_fuera_de_rango': 'Credolab lo aprobó, pero su edad está fuera del rango del grupo de su empleo',
      'hibrido:sin_datos_mt': 'Credolab lo aprobó, pero no se pudo validar su edad y empleo',
    };
    const motivo = this.analysis_response?.reconsideracion?.motivo;
    return (motivo && map[motivo]) || motivo || '';
  }

  getPolicyModeTooltip(mode: string | null | undefined): string {
    const map: Record<string, string> = {
      FIXED_MT: 'Siempre decide MT Scoring; Credolab corre pero no es decisivo',
      FIXED_CREDOLAB: 'Siempre decide Credolab; MT corre pero no es decisivo',
      REQUIRE_BOTH: 'Ambos motores deben aprobar para que la decisión final sea APROBADO',
      SPLIT_50_50_HASH: 'Hash determinista del usuario decide cuál motor es autoritativo',
      ALTERNATING_ROTATION: 'Los motores alternan 1-a-1 — cada decisión cambia el próximo turno',
      FIXED_MT_FALLBACK: 'Modo degradado: fuerza MT porque Credolab falló',
      HYBRID_CREDOLAB_MT: 'Decide Credolab; si aprueba, exige la edad y el empleo de MT (sin sueldo). Sin datos de Credolab, decide MT',
    };
    if (!mode) return '';
    return map[mode] ?? mode;
  }

  setManual_verification = async (data: any) => {
    debugger;
    Swal.fire({
      title: `¿Estas seguro que deseas realizar esta acción?`,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      input: 'textarea',
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      cancelButtonText: `Cancelar`,
      confirmButtonText: `Si`,
      showLoaderOnConfirm: true,
      preConfirm: async (login) => {
        try {
          if (login?.trim() == '') {
            return Swal.showValidationMessage(`Debe añadir una razón `);
          }
        } catch (error) {
          Swal.showValidationMessage(`
          Request failed: ${error}
        `);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        try {
          this.loading_mv = true;
          let params = {
            person_code: this.person?.person?.code,
            verified: data,
            comments: result?.value,
          };

          const analysis = await this._user.setManual_verification(params);

          this.loading_mv = false;
          this.getInReview(this.person);
          this.showButtons = false;
          this.manual_verification();
          this.getHistoryVerificationManual();
        } catch (error) {
          this.loading_mv = false;
        }
      }
    });
  };

  manual_verification = async () => {
    debugger;
    try {
      let params = {
        person_code: this.person?.person?.code,
      };

      const manual_verification_list = await this._user.getManual_verification(
        params
      );

      this.manual_verification_list = manual_verification_list;
      console.log(this.manual_verification_list);

      this.loading_mv = false;
      this.getInReview(this.person);
    } catch (error) {
      console.log(error);
    }
  };

  setAnalysis = async (item: any, reload = true) => {
    try {
      this.loading_analysis = true;
      let params = {
        codePerson: item?.person?.code,
        external: false,
        updateScore: false,
        step: '',
      };

      const analysis = await this._user.setAnalysis(params);

      this.analysis_response = analysis?.result;
      this.getPerson();

      this.loading_analysis = false;
    } catch (error) {
      this.loading_analysis = false;
    }
  };

  getEmailContact(item: any) {
    if (!(item?.constacts?.length > 0) || !item?.constacts[1]) return '';

    return `${item?.constacts[1]?.contact}`;
  }

  pocisionBottomBiometric = async (
    content: TemplateRef<any>,
    data: any = {}
  ) => {
    debugger;
    try {
      this.loading_bio = true;
      this.loading_bio_h = true;

      const offcanvasRef = this.offcanvasService.open(content, {
        position: 'bottom',
        keyboard: false,
      });

      // Guardar referencia para poder cerrarlo desde el modal principal
      this.biometricOffcanvasRef = offcanvasRef;

      // Si viene de revisión, al cerrar el offcanvas también cerrar el modal principal
      if (this.fromRevision && this.isModal) {
        offcanvasRef.result.then(
          () => {
            console.log('Offcanvas biométrico cerrado, cerrando modal principal...');
            this.biometricOffcanvasRef = null;
            this.onComplete.emit({ success: true });
          },
          () => {
            console.log('Offcanvas biométrico cancelado, cerrando modal principal...');
            this.biometricOffcanvasRef = null;
            this.onClose.emit();
          }
        );
      } else {
        // Limpiar referencia cuando se cierre el offcanvas
        offcanvasRef.result.then(
          () => { this.biometricOffcanvasRef = null; },
          () => { this.biometricOffcanvasRef = null; }
        );
      }

      const biometria = await this.biometrics_data();

      this.biometria_data = biometria;
      console.log(this.biometria_data);
      if (this.biometria_data?.person_biometric?.status !== undefined) {
        switch (this.biometria_data.person_biometric.status) {
          case 'Declined':
            this.declinedStatus = true;
            break;
          case 'Abandoned':
            this.abandonedStatus = true;
            break;
          case 'Accepted':
            this.approvedStatus = true;
            break;
        }
      }

      this.showButtons = !this.manual_verification_list;

      this.loading_bio = false;
    } catch (error) {
      console.log(error);

      this.loading_bio = false;
    }

    try {
      const biometrics_h = await this.biometrics_history();
      this.biometrics_h = biometrics_h;

      this.loading_bio_h = false;
    } catch (error) {
      this.loading_bio_h = false;
    }
  };

  biometrics_data = async () => {
    let params = {
      person_code: this.person?.person.code,
    };
    return this._user.biometrics_data(params);

    // if (this.biometria_data?.person?.person_customer?.biometric_enabled) {
    //   this.biometricEnabledStatus = true;
    // }
  };

  biometrics_history = async () => {
    let params = {
      person_code: this.person?.person.code,
    };

    return this._user.biometrics_history(params);
  };

  manual_approve = async (code: any, status: any, action: any) => {
    Swal.fire({
      title: `¿Estas seguro que deseas ${action} manualmente?`,
      text: '¡No podrás revertir esto!',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      input: 'textarea',
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      confirmButtonText: `Si, ${action} !`,
      showLoaderOnConfirm: true,
      preConfirm: async (login) => {
        try {
          if (login?.trim() == '') {
            return Swal.showValidationMessage(`Debe añadir una razón `);
          }
        } catch (error) {
          Swal.showValidationMessage(`
          Request failed: ${error}
        `);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        let params = {
          codePerson: code,
          description: result?.value,
          status: status,
        };

        try {
          let resp = await this._user.manual_approve(params);
          alertifyjs.success(`Accion exitosa`);

          this.getPerson();
        } catch (error: any) {
          console.log(error);
        }
      }
    });
  };

  refreshBiometricPhoto = async (code_person: any, image_type: any) => {
    debugger;
    try {
      const isSelfie = image_type === 'SELFIE';
      const counter = isSelfie
        ? ++this.selfieClickCounter
        : ++this.ciClickCounter;
      this.setLoadingState(image_type, true);

      if (counter >= 3) {
        this.setLoadingState(image_type, false);
        this.setShowMessage(image_type, true);
        return;
      }

      const resp = await this._user.getPersonImageRefresh(
        code_person,
        image_type
      );
      console.log(resp);

      if (resp?.pudoObtenerCI == false) {
        alertifyjs.error('No tiene imagen de CI');
      }

      if (resp?.pudoObtenerSelfie == false) {
        alertifyjs.error('No tiene imagen de selfie');
      }

      const updatedBiometrics = await this.biometrics_data();
      this.biometria_data = updatedBiometrics;
    } catch (error: any) {
      alertifyjs.error('Error al consultar imagen: ' + error.error.msg);
      console.error('Error fetching the image:', error);
    } finally {
      this.setLoadingState(image_type, false);
    }
  };

  refreshBiometricStatus = async (code_person: any) => {
    debugger;
    try {
      const counter = ++this.biometricStatusCounter;
      this.statusLoading = true;

      if (counter >= 3) {
        this.statusLoading = false;
        this.showStatusMsg = true;
        return;
      }

      const resp = await this._user.personBiometricStatusRefresh(code_person);
      console.log(resp);

      const updatedBiometrics = await this.biometrics_data();
      this.biometria_data = updatedBiometrics;
    } catch (error) {
      alertifyjs.error('Error al consultar estatus');
      console.error('Error fetching the status:', error);
    } finally {
      this.statusLoading = false;
    }
  };

  setLoadingState(image_type: string, isLoading: boolean) {
    if (image_type === 'SELFIE') {
      this.loading_img = isLoading;
    } else if (image_type === 'CI') {
      this.loading = isLoading;
    }
  }

  setShowMessage(image_type: string, showMessage: boolean) {
    if (image_type === 'SELFIE') {
      this.showSelfieMsg = showMessage;
    } else if (image_type === 'CI') {
      this.showCiMsg = showMessage;
    }
  }

  async enableBiometric(person_code: any) {
    this.loadingBiometric = true;
    try {
      const body = {
        person_code: person_code,
      };
      const resp = await this._user.enableBiometricPerson(body);
      console.log(resp);
      alertifyjs.success('Biometría habilitada');
      const updatedBiometrics = await this.biometrics_data();
      this.biometria_data = updatedBiometrics;
    } catch (error) {
      console.error(error);
      alertifyjs.error('No se pudo habilitar la biometría');
    } finally {
      this.loadingBiometric = false;
    }
  }

  verifyHistory(){
    this.history = !this.history;
  }

  async getHistoryVerificationManual(){
    try {

      const resp = await this._user.getPersonbyCode({
        code: this.queryParams.code,
      })

      this.person = resp.resp;

      let params = {
        person_code: this.person?.person?.code,
      }

      const historyList = await this._user.historyManualVerification(params);

      this.historyList = historyList;


    } catch (error) {
      throw error;
    }
  }


  pocisionBottomSelfie = async (
    content: TemplateRef<any>,
    data: any = {}
  ) => {
    try {
      this.offcanvasService.open(content, {
        position: 'bottom',
        keyboard: false,
      });
    } catch (error) {
      console.log(error);
    }
  };


  pocisionBottomIdentity = async (
    content: TemplateRef<any>,
    data: any = {}
  ) => {
    try {

      this.offcanvasService.open(content, {
        position: 'bottom',
        keyboard: false,
      });
    } catch (error) {
      console.log(error);
    }
  };

  toggleStepExpansion(stepKey: string): void {
    this.expandedSteps[stepKey] = !this.expandedSteps[stepKey];
  }

  // Helper method to determine if progress section should be shown
  shouldShowProgressSection(): boolean {
    return !this.loading && !!this.person?.person;
  }

  // Helper method to determine if section data is available
  hasSectionData(): boolean {
    return !!this.section_transaction && Array.isArray(this.section_transactions) && this.section_transactions.length > 0;
  }

  // Método para copiar número de teléfono al portapapeles
  async copyPhoneToClipboard(person: any): Promise<void> {
    try {
      const phoneNumber = this.getContact(person);
      if (phoneNumber) {
        // Remover el +58 si existe
        const cleanNumber = phoneNumber.replace(/^\+58/, '');
        
        // Copiar al portapapeles
        await navigator.clipboard.writeText(cleanNumber);
        
        // Mostrar notificación con alertifyjs
        alertifyjs.success(`Número copiado al portapapeles`);
      }
    } catch (error) {
      console.error('Error al copiar número:', error);
      // Fallback para navegadores que no soportan navigator.clipboard
      this.fallbackCopyToClipboard(person);
    }
  }

  // Método fallback para copiar en navegadores más antiguos
  fallbackCopyToClipboard(person: any): void {
    try {
      const phoneNumber = this.getContact(person);
      if (phoneNumber) {
        const cleanNumber = phoneNumber.replace(/^\+58/, '');
        
        // Crear elemento temporal
        const textArea = document.createElement('textarea');
        textArea.value = cleanNumber;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        
        // Mostrar notificación con alertifyjs
        alertifyjs.success(`Número copiado al portapapeles`);
      }
    } catch (error) {
      console.error('Error en fallback de copiado:', error);
    }
  }

  goBack(): void {
    if (this.person?.person?.code) {
      this.router.navigate(['/console/person/profile', this.person.person.code]);
    } else {
      // Fallback en caso de que no haya código de persona disponible
    this.router.navigate(['/console/search-client']);
    }
  }

  // Methods to navigate to specific sections
  editBasicData() {
    this.setChangView(7);
    this.pocisionBottom(this.content);
  }

  editPaymentMethods() {
    console.log('💳 [editPaymentMethods] Abriendo modal de payment methods');
    this.setChangView(5);
    this.pocisionBottom(this.content);
  }

  openProfileDataModal() {
    this.setChangView(1);
    this.pocisionBottom(this.content);
  }

  // Métodos para manejo del modal
  closeOnboarding() {
    if (this.isModal) {
      this.onClose.emit();
    } else {
      this.goBack();
    }
  }

  saveAndComplete() {
    // Emitir evento de completado con datos relevantes
    const result = {
      success: true,
      personCode: this.person?.person?.code,
      changes: this.getChangesData()
    };
    
    if (this.isModal) {
      this.onComplete.emit(result);
    } else {
      // Comportamiento normal para página completa
      alertifyjs.success('Cambios guardados correctamente');
    }
  }

  private getChangesData() {
    return {
      biometricStatus: this.person?.person?.person_biometric_status,
      onboardingStatus: this.person?.person?.onboarding_status,
      approveStatus: this.person?.person?.approve_status,
      lastUpdate: new Date().toISOString()
    };
  }

  // Método para abrir modal biométrico manualmente (si se necesita en el futuro)
  openBiometricModalFromRevision() {
    if (this.person) {
      // Abrir directamente la sección de biometría
      this.setChangView(2);
      if (this.content3) {
        this.pocisionBottomBiometric(this.content3);
      }
    }
  }

  // Métodos para editar fecha de nacimiento en modal biométrico
  startEditingBirthDate() {
    this.editingBirthDate = true;
    if (this.person?.person?.birth_date) {
      this.birthDateEdit = new Date(this.person.person.birth_date);
      this.birthDateEditString = this.datePipe.transform(this.birthDateEdit, 'MM/dd/yyyy');
    }
  }

  cancelEditingBirthDate() {
    this.editingBirthDate = false;
    this.birthDateEdit = null;
    this.birthDateEditString = null;
  }

  onBirthDateSet(e: any) {
    let date_value = e.valueText; // Formato: "dd/mm/yyyy"
    let temp = date_value ? date_value.split("/") : [];
    // Convierte de dd/mm/yyyy a MM/dd/yyyy
    this.birthDateEditString = `${temp[1]}/${temp[0]}/${temp[2]}`;
  }

  // Método público para cerrar el offcanvas biométrico desde el modal principal
  closeBiometricOffcanvas() {
    if (this.biometricOffcanvasRef) {
      console.log('Cerrando offcanvas biométrico...');
      this.biometricOffcanvasRef.dismiss('Modal principal cerrado');
      this.biometricOffcanvasRef = null;
    }
  }

  async saveBirthDate() {
    if (!this.birthDateEditString) {
      alertifyjs.error('Debe seleccionar una fecha válida');
      return;
    }

    try {
      this.savingBirthDate = true;

      // Buscar contactos actuales
      const phoneCellContact = this.person?.constacts?.find((c:any) => c?.type_contact?.code === 'PHONE_CELL');
      const emailContact = this.person?.constacts?.find((c:any) => c?.type_contact?.code === 'EMAIL');
      const additionalPhoneContact = this.person?.constacts?.find((c:any) => c?.type_contact?.code === 'ADDITIONAL_PHONE');

      // Construir array de contactos
      let contact = [
        { 
          type_contact: "PHONE_CELL",
          verificated_contact: phoneCellContact?.verificated_contact || false,
          contact: phoneCellContact?.contact || '',
          contact_oll: phoneCellContact?.contact || ''
        },
        { 
          type_contact: "EMAIL",
          verificated_contact: emailContact?.verificated_contact || false,
          contact: emailContact?.contact || '',
          contact_oll: emailContact?.contact || ''
        }
      ];

      // Agregar teléfono adicional si existe
      if (additionalPhoneContact?.contact) {
        contact.push({
          type_contact: "ADDITIONAL_PHONE",
          verificated_contact: false,
          contact: additionalPhoneContact.contact,
          contact_oll: additionalPhoneContact.contact
        });
      }

      // Construir parámetros con TODA la información
      const params = {
        name: this.person?.person?.name,
        lastName: this.person?.person?.lastName,
        second_name: this.person?.person?.second_name || '',
        second_lastName: this.person?.person?.second_lastName || '',
        code_person: this.person?.person?.code,
        contact: contact,
        birth_date: this.birthDateEditString,
      };

      console.log('=== GUARDANDO FECHA DE NACIMIENTO ===');
      console.log('Parámetros enviados:', params);
      
      const response = await this._user.update_person(params);
      console.log('Respuesta del servidor:', response);
      
      alertifyjs.success('Fecha de nacimiento actualizada exitosamente');
      
      // Recargar datos de la persona
      console.log('Recargando datos de persona...');
      await this.getPerson();
      console.log('Fecha después de recargar person:', this.person?.person?.birth_date);
      
      // Salir del modo edición
      this.editingBirthDate = false;
      this.birthDateEdit = null;
      this.birthDateEditString = null;
      
    } catch (error: any) {
      console.error('Error al actualizar fecha de nacimiento:', error);
      alertifyjs.error('Error al actualizar la fecha de nacimiento');
    } finally {
      this.savingBirthDate = false;
    }
  }
}
